import { useState, useEffect } from "react";
import { API } from "../App";
import { Wifi, WifiOff, AlertTriangle } from "lucide-react";

const ConnectionStatus = () => {
  const [status, setStatus] = useState("checking"); // checking, healthy, degraded, offline
  const [latency, setLatency] = useState(null);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const start = Date.now();
        const response = await fetch(`${API}/health`, { 
          method: "GET",
          cache: "no-store"
        });
        const elapsed = Date.now() - start;
        setLatency(elapsed);
        
        if (response.ok) {
          setStatus(elapsed > 2000 ? "degraded" : "healthy");
        } else {
          setStatus("degraded");
        }
      } catch (error) {
        setStatus("offline");
        setLatency(null);
      }
    };

    // Check immediately
    checkHealth();
    
    // Then check every 30 seconds
    const interval = setInterval(checkHealth, 30000);
    
    return () => clearInterval(interval);
  }, []);

  // Don't show anything if healthy
  if (status === "healthy" || status === "checking") {
    return null;
  }

  return (
    <div 
      className={`fixed bottom-4 left-4 z-50 flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium shadow-lg ${
        status === "degraded" 
          ? "bg-amber-100 text-amber-800 border border-amber-300" 
          : "bg-red-100 text-red-800 border border-red-300"
      }`}
    >
      {status === "degraded" ? (
        <>
          <AlertTriangle className="w-4 h-4" />
          <span>Slow connection ({latency}ms)</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4" />
          <span>Connection lost - Retrying...</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
